import { Check, Palette } from '@phosphor-icons/react'
import { Button, Popover, Tooltip } from 'antd'
import { useState } from 'react'

import cn from '@/utils/tailwind/cn'

import { getThemeFromCustomCompletePage } from '../../UtilsCompletePage/getThemeFromCustomCompletePage'
import { upsertCustomCompletePageTheme } from '../../UtilsCompletePage/upsertCustomCompletePageTheme'
import { StateCustomPageEditorProps } from './CustomPageEditor'

export const CustomPageTheme = ({
  data,
  setData,
}: StateCustomPageEditorProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const closePopover = () => setIsOpen(false)

  const themeColors = [
    { id: 'success-dark', color: '#2e7d4f' },
    { id: 'success', color: '#51a855' },
    { id: 'success-light', color: '#68bf6c' },

    { id: 'warning-dark', color: '#b45309' },
    { id: 'warning', color: '#f59e0b' },
    { id: 'warning-light', color: '#fbd75f' },

    { id: 'error-dark', color: '#c53030' },
    { id: 'error', color: '#ef4444' },
    { id: 'error-light', color: '#fa6f6f' },

    { id: 'info-dark', color: '#2563eb' },
    { id: 'info', color: '#3b82f6' },
    { id: 'info-light', color: '#6cacff' },
  ]

  const currentTheme = getThemeFromCustomCompletePage(data)

  const onChangeTheme = (input: string | null | undefined, content: string) => {
    const newContent = upsertCustomCompletePageTheme(input, content)
    setData(newContent)
  }

  return (
    <Tooltip mouseEnterDelay={0.2} title="Edit color theme">
      <Popover
        classNames={{ body: '!px-0' }}
        content={
          <div className="grid w-full grid-cols-3 items-center justify-center gap-2.5 px-2.5">
            {themeColors.map((item) => {
              const isActive = (currentTheme || '#51a855') === item.color
              return (
                <button
                  className={cn(
                    'flex h-[21px] w-[21px] items-center justify-start rounded-full border border-gray-100/10 outline-none hover:opacity-70 focus:outline-none disabled:cursor-not-allowed',
                    isActive && 'shadow'
                  )}
                  key={item.id}
                  onClick={() => {
                    onChangeTheme(data, item.color)
                    closePopover()
                  }}
                  style={{ background: item.color }}
                  type="button"
                >
                  {isActive ? (
                    <Check
                      className="mb-0.5 ml-0.5 text-sm text-white"
                      weight="bold"
                    />
                  ) : null}
                </button>
              )
            })}
          </div>
        }
        getPopupContainer={() => document.body}
        onOpenChange={() => setIsOpen((old) => !old)}
        open={isOpen}
        placement="top"
        trigger="click"
      >
        <Button
          className="absolute -top-10 right-4 h-11 w-11 rounded-full p-0 !text-gray-500 !outline-none hover:!text-primary"
          type="link"
        >
          <Palette className="text-xl" weight="bold" />
        </Button>
      </Popover>
    </Tooltip>
  )
}
